<template>
  <b-card border-variant="dark" class="rounded-custom-1 border-custom-2">
    <div class="sign-up-title text-center mb-2">
      Connect to your workspace
    </div>
    <b-row class="justify-content-center mt-5 mb-2">
      <b-col md="12" lg="9">
        <b-card border-variant="dark" class="rounded-custom-1 border-custom-2">
          <b-row class="justify-content-center">
            <b-col md="12" lg="10">
              <h4 class="mb-5 text-center">Enter your workplace URL</h4>
              <connect-to-workspace-form :submitting="submitting" :state="state" @submit="onSubmit" />
              <h5 class="text-center mt-4"><b-link :to="{ name: 'ForgotWorkspace' }">Forgot your workspace URL?</b-link></h5>
            </b-col>
          </b-row>
        </b-card>
        <div class="text-center mt-4">
          <h5>Don't have a workspace?</h5>
          <h5><b-link :to="{ name: 'CreateWorkspace' }" class="btn-link-primary">Create one here</b-link></h5>
        </div>
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
import ConnectToWorkspaceForm from '@/components/forms/ConnectToWorkspaceForm.vue'

export default {
  name: 'ConnectToWorkspace',

  data() {
    return {
      state: {},
      submitting: false
    }
  },

  methods: {
    stateHandler(errors) {
      return {
        companySlug: [
          'Workspace does not exist. Enter a valid workspace name consisting of letters, numbers, underscores or hyphens.'
        ]
      }
    },

    onSubmit(data) {
      this.submitting = true
      this.$store.dispatch('fetchCompany', data.companySlug)
        .then(() => {
          this.$router.push({ name: 'Login' })
        })
        .catch(errors => { this.state = this.stateHandler(errors) })
        .finally(() => { this.submitting = false })
    }
  },

  components: {
    ConnectToWorkspaceForm
  }
}
</script>
